import colors_255 from "../../assets/json/colors-255.json";
import constants from "./constants";

import Cookie from 'js-cookie'

const EYE_IMAGE = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAxElEQVR4nO2SsQ3CQAxFHxE9jJANYISskAkIza/DBIQJSO0GNoANyApswAiwAUV+xIFEgaiQcGU/3/86+w5+PkavICJyoAYKYGZ8BjqglXR5axARFbBzubEIm62dLyXtB02WiOtEXEpqgByogCNQurfz2YdBRBTAdriupKPzObAAOrOz+dYaxgZNMsnVzVPCJmbXhDVAkSXFEFNJHXBL2M1s+mLwWKLnGsYogQv9awC09Ps4uF5Jap8MbFLx4St8/Q/+AXdY5kgt7Ls3lQAAAABJRU5ErkJggg==";
const EYE_IMAGE_SLASHED = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABCUlEQVR4nMWSwVGDUBCGP21AOpAOjBVIByYVSC7/GSuQVBDOe4ESKIF0EDuIHSQd5MCPMHBwogd3hpnH291v/9198FeLiCQi8t/m3wNroI6INiKSWwF3VlEAe+ALKIAVkAEvjvsEOqCSdFoADFkBLfDoq52TMOzD562kZtrCYCdXPvg/9VcYvPF9bcUjICIyV0slZa7+BtTAq32dWwHYO+dbQQk8AV1E5JJKV7zY/2B154nicg4YAksASa2ThqprIJkDpkMs6DcBs0FFROOWBttZ5QhwYE7fN4xbOEs62ldZ5bOk4wJgSEo/+Yx+LgAbSe1s1e+SqgXgJ/Nrbei3s70ZMAHlVvPPdgVK7V4Cn84qGgAAAABJRU5ErkJggg==";

class LegendDOM {

  constructor(options = {}) {
    // variables
    this.options = options;
    this.unique_diseases = [];
    this.pedigree_notes_focused = false;

    // methods
    this.setNotesFocused = this.setNotesFocused.bind(this);
    this.getNotesFocused = this.getNotesFocused.bind(this);
    this.initialize = this.initialize.bind(this);
    this.initializeLegendContainer = this.initializeLegendContainer.bind(this);
    this.initializeHeader = this.initializeHeader.bind(this);
    this.dragElement = this.dragElement.bind(this);
    this.setUniqueDiseases = this.setUniqueDiseases.bind(this);
    this.getColor = this.getColor.bind(this);
    this.loadDiseases = this.loadDiseases.bind(this);
    this.renderEyeColumn = this.renderEyeColumn.bind(this);
    this.renderEyeImg = this.renderEyeImg.bind(this);
    this.renderNameColumn = this.renderNameColumn.bind(this);
    this.onCloseClicked = this.onCloseClicked.bind(this);
    this.loadNotes = this.loadNotes.bind(this);
    this.createNotes = this.createNotes.bind(this);
    this.redrawLegend = this.redrawLegend.bind(this);

    this.initialize();
  }

  setNotesFocused(focused) {
    this.pedigree_notes_focused = focused;
  }

  getNotesFocused() {
    return this.pedigree_notes_focused;
  }

  initialize() {
    this.initializeLegendContainer();
    // this.initializeHeader();
    this.dragElement(this.container_element);

    this.setUniqueDiseases();
    if(this.options.showDiseases) this.loadDiseases();
    if(this.options.showNotes) this.loadNotes();
  }

  initializeLegendContainer() {
    // create legend container element
    this.container_element = document.createElement('div');
    this.container_element.setAttribute('class', 'legend-dom');
    this.container_element.setAttribute('id', constants.LEGEND_DOM_CONTAINER_ELEMENT);
    this.container_element.addEventListener('mouseenter', () => {
      document.body.style.cursor = "move";
    });

    this.container_element.addEventListener('mouseleave', () => {
      document.body.style.cursor = "default";
    });

    const left = `left:${this.options.left}px;`;
    const top = `top:${this.options.top}px;`;

    const height = `height:fit-content;`;
    const width = `width:${this.options.width}px;`;

    const maxHeight = `max-height: ${window.innerHeight - this.options.top}px;`;

    const style_string = left + top + height + width + maxHeight;
    this.container_element.setAttribute('style', style_string);

    this.options.parentNode.appendChild(this.container_element);
  }

  initializeHeader() {
    const header = document.createElement('div');
    header.setAttribute('class', 'legend-dom-header');

    // create close button element
    const close_btn = document.createElement('div');
    close_btn.setAttribute('class', 'dismiss');
    close_btn.addEventListener('click', this.onCloseClicked);

    // create close button icon element
    const close_icon = document.createElement('i');
    close_icon.setAttribute('class', 'fa fa-close');

    // add elements to appropriate containers
    close_btn.appendChild(close_icon);
    header.appendChild(close_btn);
    this.container_element.appendChild(header);
  }

  dragElement(elmnt) {
    var pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;
    elmnt.onmousedown = dragMouseDown;

    const getNotesFocused = this.getNotesFocused;

    function dragMouseDown(e) {
      const notes_focused = getNotesFocused();
      if (notes_focused) return;
      
      e = e || window.event;
      e.preventDefault();

      document.body.style.cursor = "grab";

      // get the mouse cursor position at startup:
      pos3 = e.clientX;
      pos4 = e.clientY;
      document.onmouseup = closeDragElement;

      // call a function whenever the cursor moves:
      document.onmousemove = elementDrag;
    }

    function elementDrag(e) {
      e = e || window.event;
      e.preventDefault();

      // calculate the new cursor position:
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;

      // set the element's new position:
      elmnt.style.top = (elmnt.offsetTop - pos2) + "px";
      elmnt.style.left = (elmnt.offsetLeft - pos1) + "px";
    }

    function closeDragElement(e) {
      const coordinates = [elmnt.offsetTop, elmnt.offsetLeft];
      window.localStorage.setItem("famgenix_legend_center", JSON.stringify(coordinates));

      /* stop moving when mouse button is released:*/
      document.onmouseup = null;
      document.onmousemove = null;
      document.body.style.cursor = "move";
    }
  }

  setUniqueDiseases() {
    const allDiseasesOnPedigree = [];
    for(let x=0; x<this.options.historyDiseases.length; x++){
      for(let i=0; i<this.options.historyDiseases[x].length; i++){
        allDiseasesOnPedigree.push(this.options.historyDiseases[x][i]);
      }
    }

    allDiseasesOnPedigree.sort((a, b) => a.disease_id - b.disease_id);

    const key = 'disease_id';
    const uniqueDiseases = [...new Map(allDiseasesOnPedigree.slice().reverse().map(item =>
    [item[key], item])).values()];

    let displayBlackAndWhite = Cookie.get('famgenix_pedigree_black_and_white');
    const displayBlackAndWhiteBool = displayBlackAndWhite === 'true';

    uniqueDiseases.sort((a, b) => a.id - b.id);
    for(let x=0; x<uniqueDiseases.length; x++) {
      if(displayBlackAndWhiteBool){
        uniqueDiseases[x].color = this.getSVGImageDataURI(uniqueDiseases[x].disease_id, uniqueDiseases);
      }
      else{
        uniqueDiseases[x].color = this.getColor(uniqueDiseases[x].disease_id, uniqueDiseases, x);
      }
    }

    let filteredDiseases = uniqueDiseases;

    //Clean up array
    filteredDiseases = filteredDiseases.filter(disease => disease != undefined);
    filteredDiseases = [...new Map(filteredDiseases.slice().reverse().map(item =>
    [item[key], item])).values()];
    filteredDiseases.sort((a, b) => {
      if (a.disease_name < b.disease_name) {
        return -1;
      }
      if (a.disease_name > b.disease_name) {
        return 1;
      }
      // a must be equal to b
      return 0;
    });

    this.unique_diseases = filteredDiseases;
  }

  getSVGImageDataURI(digit, unique_diseases){
    // solid black
    let img1 = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25' height='100%25' viewBox='0 0 1600 800'%3E%3Cg %3E%3Cpath fill='%23000000' d='M486 705.8c-109.3-21.8-223.4-32.2-335.3-19.4C99.5 692.1 49 703 0 719.8V800h843.8c-115.9-33.2-230.8-68.1-347.6-92.2C492.8 707.1 489.4 706.5 486 705.8z'/%3E%3Cpath fill='%23000000' d='M1600 0H0v719.8c49-16.8 99.5-27.8 150.7-33.5c111.9-12.7 226-2.4 335.3 19.4c3.4 0.7 6.8 1.4 10.2 2c116.8 24 231.7 59 347.6 92.2H1600V0z'/%3E%3Cpath fill='%23000000' d='M478.4 581c3.2 0.8 6.4 1.7 9.5 2.5c196.2 52.5 388.7 133.5 593.5 176.6c174.2 36.6 349.5 29.2 518.6-10.2V0H0v574.9c52.3-17.6 106.5-27.7 161.1-30.9C268.4 537.4 375.7 554.2 478.4 581z'/%3E%3Cpath fill='%23000000' d='M0 0v429.4c55.6-18.4 113.5-27.3 171.4-27.7c102.8-0.8 203.2 22.7 299.3 54.5c3 1 5.9 2 8.9 3c183.6 62 365.7 146.1 562.4 192.1c186.7 43.7 376.3 34.4 557.9-12.6V0H0z'/%3E%3Cpath fill='%23000000' d='M181.8 259.4c98.2 6 191.9 35.2 281.3 72.1c2.8 1.1 5.5 2.3 8.3 3.4c171 71.6 342.7 158.5 531.3 207.7c198.8 51.8 403.4 40.8 597.3-14.8V0H0v283.2C59 263.6 120.6 255.7 181.8 259.4z'/%3E%3Cpath fill='%23000000' d='M1600 0H0v136.3c62.3-20.9 127.7-27.5 192.2-19.2c93.6 12.1 180.5 47.7 263.3 89.6c2.6 1.3 5.1 2.6 7.7 3.9c158.4 81.1 319.7 170.9 500.3 223.2c210.5 61 430.8 49 636.6-16.6V0z'/%3E%3Cpath fill='%23000000' d='M454.9 86.3C600.7 177 751.6 269.3 924.1 325c208.6 67.4 431.3 60.8 637.9-5.3c12.8-4.1 25.4-8.4 38.1-12.9V0H288.1c56 21.3 108.7 50.6 159.7 82C450.2 83.4 452.5 84.9 454.9 86.3z'/%3E%3Cpath fill='%23000000' d='M1600 0H498c118.1 85.8 243.5 164.5 386.8 216.2c191.8 69.2 400 74.7 595 21.1c40.8-11.2 81.1-25.2 120.3-41.7V0z'/%3E%3Cpath fill='%23000000' d='M1397.5 154.8c47.2-10.6 93.6-25.3 138.6-43.8c21.7-8.9 43-18.8 63.9-29.5V0H643.4c62.9 41.7 129.7 78.2 202.1 107.4C1020.4 178.1 1214.2 196.1 1397.5 154.8z'/%3E%3Cpath fill='%23000000' d='M1315.3 72.4c75.3-12.6 148.9-37.1 216.8-72.4h-723C966.8 71 1144.7 101 1315.3 72.4z'/%3E%3C/g%3E%3C/svg%3E")`
    // solid #b2b2b2
    let img2 = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25' height='100%25' viewBox='0 0 1600 800'%3E%3Cg %3E%3Cpath fill='%23b2b2b2' d='M486 705.8c-109.3-21.8-223.4-32.2-335.3-19.4C99.5 692.1 49 703 0 719.8V800h843.8c-115.9-33.2-230.8-68.1-347.6-92.2C492.8 707.1 489.4 706.5 486 705.8z'/%3E%3Cpath fill='%23b2b2b2' d='M1600 0H0v719.8c49-16.8 99.5-27.8 150.7-33.5c111.9-12.7 226-2.4 335.3 19.4c3.4 0.7 6.8 1.4 10.2 2c116.8 24 231.7 59 347.6 92.2H1600V0z'/%3E%3Cpath fill='%23b2b2b2' d='M478.4 581c3.2 0.8 6.4 1.7 9.5 2.5c196.2 52.5 388.7 133.5 593.5 176.6c174.2 36.6 349.5 29.2 518.6-10.2V0H0v574.9c52.3-17.6 106.5-27.7 161.1-30.9C268.4 537.4 375.7 554.2 478.4 581z'/%3E%3Cpath fill='%23b2b2b2' d='M0 0v429.4c55.6-18.4 113.5-27.3 171.4-27.7c102.8-0.8 203.2 22.7 299.3 54.5c3 1 5.9 2 8.9 3c183.6 62 365.7 146.1 562.4 192.1c186.7 43.7 376.3 34.4 557.9-12.6V0H0z'/%3E%3Cpath fill='%23B2B2B2' d='M181.8 259.4c98.2 6 191.9 35.2 281.3 72.1c2.8 1.1 5.5 2.3 8.3 3.4c171 71.6 342.7 158.5 531.3 207.7c198.8 51.8 403.4 40.8 597.3-14.8V0H0v283.2C59 263.6 120.6 255.7 181.8 259.4z'/%3E%3Cpath fill='%23b2b2b2' d='M1600 0H0v136.3c62.3-20.9 127.7-27.5 192.2-19.2c93.6 12.1 180.5 47.7 263.3 89.6c2.6 1.3 5.1 2.6 7.7 3.9c158.4 81.1 319.7 170.9 500.3 223.2c210.5 61 430.8 49 636.6-16.6V0z'/%3E%3Cpath fill='%23b2b2b2' d='M454.9 86.3C600.7 177 751.6 269.3 924.1 325c208.6 67.4 431.3 60.8 637.9-5.3c12.8-4.1 25.4-8.4 38.1-12.9V0H288.1c56 21.3 108.7 50.6 159.7 82C450.2 83.4 452.5 84.9 454.9 86.3z'/%3E%3Cpath fill='%23b2b2b2' d='M1600 0H498c118.1 85.8 243.5 164.5 386.8 216.2c191.8 69.2 400 74.7 595 21.1c40.8-11.2 81.1-25.2 120.3-41.7V0z'/%3E%3Cpath fill='%23b2b2b2' d='M1397.5 154.8c47.2-10.6 93.6-25.3 138.6-43.8c21.7-8.9 43-18.8 63.9-29.5V0H643.4c62.9 41.7 129.7 78.2 202.1 107.4C1020.4 178.1 1214.2 196.1 1397.5 154.8z'/%3E%3Cpath fill='%23B2B2B2' d='M1315.3 72.4c75.3-12.6 148.9-37.1 216.8-72.4h-723C966.8 71 1144.7 101 1315.3 72.4z'/%3E%3C/g%3E%3C/svg%3E")`
    // brick wall vertical
    let img3 = `url("data:image/svg+xml,<svg id='patternId' width='100%' height='100%' xmlns='http://www.w3.org/2000/svg'><defs><pattern id='a' patternUnits='userSpaceOnUse' width='30' height='30' patternTransform='scale(0.25) rotate(90)'><rect x='0' y='0' width='100%' height='100%' fill='hsla(0,0%,100%,1)'/><path d='M0 22.5h30v15H0zm15-15h30v15H15m-30-15h30v15h-30zm15-15h30v15H0z'  stroke-width='1' stroke='hsla(259, 0%, 0%, 1)' fill='none'/></pattern></defs><rect width='800%' height='800%' transform='translate(0,0)' fill='url(%23a)'/></svg>")`
    // circles
    let img4 = `url("data:image/svg+xml,<svg id='patternId' width='100%' height='100%' xmlns='http://www.w3.org/2000/svg'><defs><pattern id='a' patternUnits='userSpaceOnUse' width='20' height='20' patternTransform='scale(0.5) rotate(0)'><rect x='0' y='0' width='100%' height='100%' fill='hsla(0,0%,100%,1)'/><path d='M10 15a5 5 0 110-10 5 5 0 010 10z'  stroke-width='1' stroke='hsla(259, 0%, 0%, 1)' fill='none'/></pattern></defs><rect width='800%' height='800%' transform='translate(0,0)' fill='url(%23a)'/></svg>")`
    // chevron
    let img5 = `url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' transform='scale(1)'%3e%3crect x='0' y='0' width='100%25' height='100%25' fill='hsla(0,0%25,100%25,1)'/%3e%3cpath d='M-5 5L5.1 15 15 5l10 10' stroke-linecap='square' stroke-width='1.5' stroke='hsla(0, 0%25, 0%25, 1)' fill='none'/%3e%3c/svg%3e")`
    // diagonal stripes
    let img6 = `url("data:image/svg+xml;charset=UTF-8,%3c?xml version='1.0' encoding='UTF-8' standalone='no'?%3e%3csvg width='40px' height='40px' viewBox='0 0 40 40' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3c!-- Generator: Sketch 40.1 (33804) - http://www.bohemiancoding.com/sketch --%3e%3ctitle%3ediagonal-stripes%3c/title%3e%3cdesc%3eCreated with Sketch.%3c/desc%3e%3cdefs%3e%3c/defs%3e%3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e%3cg id='diagonal-stripes' fill='%23000000'%3e%3cpolygon id='Path-2' points='0 40 40 0 20 0 0 20'%3e%3c/polygon%3e%3cpolygon id='Path-2-Copy' points='40 40 40 20 20 40'%3e%3c/polygon%3e%3c/g%3e%3c/g%3e%3c/svg%3e")`
    // diamonds
    let img7 = `url("data:image/svg+xml,<svg id='patternId' width='100%' height='100%' xmlns='http://www.w3.org/2000/svg'><defs><pattern id='a' patternUnits='userSpaceOnUse' width='50' height='50' patternTransform='scale(0.25) rotate(0)'><rect x='0' y='0' width='100%' height='100%' fill='hsla(0,0%,100%,1)'/><path d='M50 25L37.5 50 25 25 37.5 0zm-25 0L12.5 50 0 25 12.5 0z'  stroke-width='1' stroke='hsla(259, 0%, 0%, 1)' fill='none'/></pattern></defs><rect width='800%' height='800%' transform='translate(0,0)' fill='url(%23a)'/></svg>")`
    // herringbone1
    let img8 = `url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' transform='scale(1)'%3e%3crect x='0' y='0' width='100%25' height='100%25' fill='hsla(0,0%25,100%25,1)'/%3e%3cpath d='M10-10L20 0v10L10 0zM20 0L10-10V0l10 10zm0 10L10 0v10l10 10zm0 10L10 10v10l10 10zM0 20l10-10v10L0 30zm0-10L10 0v10L0 20zM0 0l10-10V0L0 10z' stroke-width='1.5' stroke='hsla(0, 0%25, 0%25, 1)' fill='none'/%3e%3c/svg%3e")`
    // jagged square
    let img9 = `url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' transform='scale(1)'%3e%3crect x='0' y='0' width='100%25' height='100%25' fill='hsla(0,0%25,100%25,1)'/%3e%3cpath d='M -5,-3 5,2 15,-3 25,2 M -5,17 5,22 15,17 25,22 M -5,7 5,12 15,7 25,12 m -27.5,12.5 5,-10 -5,-10 5,-10 m 15,30 5,-10 -5,-10 5,-10 m -15,30 5,-10 -5,-10 5,-10' stroke-width='1.5' stroke='hsla(0, 0%25, 0%25, 1)' fill='none'/%3e%3c/svg%3e")`
    // lines horiz
    let img10 = `url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' transform='scale(1)'%3e%3crect x='0' y='0' width='100%25' height='100%25' fill='hsla(0,0%25,100%25,1)'/%3e%3cpath d='M0 10h20z' stroke-width='2.5' stroke='hsla(0, 0%25, 0%25, 1)' fill='none'/%3e%3c/svg%3e")`
    // pixel dots
    let img11 = `url("data:image/svg+xml;charset=UTF-8,%3c?xml version='1.0' encoding='UTF-8' standalone='no'?%3e%3csvg width='16px' height='16px' viewBox='0 0 16 16' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3c!-- Generator: Sketch 40 (33762) - http://www.bohemiancoding.com/sketch --%3e%3ctitle%3epixel-dots%3c/title%3e%3cdesc%3eCreated with Sketch.%3c/desc%3e%3cdefs%3e%3c/defs%3e%3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e%3cg id='pixel-dots' fill='%23000000'%3e%3cpath d='M0,4.16333634e-16 L16,4.16333634e-16 L16,2 L10,2 L10,8 L16,8 L16,16 L8,16 L8,10 L2,10 L2,16 L0,16 L0,4.16333634e-16 Z M4,4 L6,4 L6,6 L4,6 L4,4 Z M12,12 L14,12 L14,14 L12,14 L12,12 Z M4,12 L6,12 L6,14 L4,14 L4,12 Z M12,4 L14,4 L14,6 L12,6 L12,4 Z' id='Combined-Shape'%3e%3c/path%3e%3c/g%3e%3c/g%3e%3c/svg%3e")`
    // stripes
    let img12 = `url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' transform='scale(1) rotate(90)'%3e%3crect x='0' y='0' width='100%25' height='100%25' fill='hsla(0,0%25,100%25,1)'/%3e%3cpath d='M0 10h20z' stroke-width='8' stroke='hsla(259, 0%25, 0%25, 1)' fill='hsla(0,0%25,100%25,1)'/%3e%3c/svg%3e")`
    // tiny checkers
    let img13 = `url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' width='8px' height='8px' viewBox='0 0 8 8'%3e%3cpath fill='%23000000' fill-rule='evenodd' d='M0 0h4v4H0V0zm4 4h4v4H4V4z'/%3e%3c/svg%3e")`
    // waves 2
    let img14 = `url("data:image/svg+xml;charset=UTF-8,%3c?xml version='1.0' encoding='UTF-8' standalone='no'?%3e%3csvg width='100px' height='20px' viewBox='0 0 100 20' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3c!-- Generator: Sketch 40 (33762) - http://www.bohemiancoding.com/sketch --%3e%3ctitle%3ebank-note%3c/title%3e%3cdesc%3eCreated with Sketch.%3c/desc%3e%3cdefs%3e%3c/defs%3e%3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e%3cg id='bank-note' fill='%23000000'%3e%3cpath d='M21.1841339,20 C21.5411448,19.869748 21.9037256,19.7358773 22.272392,19.5983261 C22.6346445,19.4631679 23.8705367,18.9999982 24.0399055,18.9366758 C33.6397477,15.3475548 39.6469349,14 50,14 C60.2711361,14 65.3618399,15.2217689 74.6286093,18.9284767 C75.584355,19.310775 76.4978747,19.6675274 77.3787841,20 L83.604005,20 C81.0931362,19.2694473 78.4649665,18.3089537 75.3713907,17.0715233 C65.8881601,13.2782311 60.5621972,12 50,12 C39.3741437,12 33.144814,13.3973866 23.3395101,17.0633242 C23.1688625,17.1271247 21.9338538,17.5899633 21.5732596,17.7245028 C19.0984715,18.6478581 16.912678,19.3994574 14.8494171,20 L21.1841339,20 L21.1841339,20 Z M21.1841339,0 C13.2575214,2.89194861 8.07672845,4 7.87150385e-14,4 L7.81597009e-14,4 L0,2 C5.74391753,2 9.9514017,1.4256397 14.8494171,1.40165657e-15 L21.1841339,6.9388939e-17 L21.1841339,0 Z M77.3787841,2.21705987e-12 C85.238555,2.9664329 90.5022896,4 100,4 L100,2 C93.1577329,2 88.6144135,1.4578092 83.604005,1.04805054e-13 L77.3787841,0 L77.3787841,2.21705987e-12 Z M7.87150385e-14,14 C8.44050043,14 13.7183277,12.7898887 22.272392,9.59832609 C22.6346445,9.46316794 23.8705367,8.99999822 24.0399055,8.9366758 C33.6397477,5.34755477 39.6469349,4 50,4 C60.2711361,4 65.3618399,5.2217689 74.6286093,8.92847669 C84.1118399,12.7217689 89.4378028,14 100,14 L100,12 C89.7288639,12 84.6381601,10.7782311 75.3713907,7.07152331 C65.8881601,3.2782311 60.5621972,2 50,2 C39.3741437,2 33.144814,3.39738661 23.3395101,7.0633242 C23.1688625,7.12712472 21.9338538,7.58996334 21.5732596,7.72450279 C13.2235239,10.8398294 8.16350991,12 0,12 L7.81597009e-14,14 L7.87150385e-14,14 L7.87150385e-14,14 Z' id='Combined-Shape'%3e%3c/path%3e%3c/g%3e%3c/g%3e%3c/svg%3e")`
    // zigzag
    let img15 = `url("data:image/svg+xml;charset=UTF-8,%3c?xml version='1.0' encoding='UTF-8' standalone='no'?%3e%3csvg width='40px' height='12px' viewBox='0 0 40 12' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3c!-- Generator: Sketch 40.1 (33804) - http://www.bohemiancoding.com/sketch --%3e%3ctitle%3ezig-zag%3c/title%3e%3cdesc%3eCreated with Sketch.%3c/desc%3e%3cdefs%3e%3c/defs%3e%3cg id='Page-1' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e%3cg id='zig-zag' fill='%23000000'%3e%3cpath d='M2.84217094e-14,6.17157288 L6.17157288,0 L11.8284271,0 L0,11.8284271 L2.84217094e-14,6.17157288 L2.84217094e-14,6.17157288 Z M40,11.8284271 L28.1715729,0 L33.8284271,3.55271368e-15 L40,6.17157288 L40,11.8284271 L40,11.8284271 Z M6.17157288,12 L18.1715729,0 L21.8284271,0 L33.8284271,12 L28.1715729,12 L20,3.82842712 L11.8284271,12 L6.17157288,12 L6.17157288,12 Z M18.1715729,12 L20,10.1715729 L21.8284271,12 L18.1715729,12 L18.1715729,12 Z' id='Combined-Shape'%3e%3c/path%3e%3c/g%3e%3c/g%3e%3c/svg%3e")`

    let digitObject = unique_diseases.find(disease => disease.disease_id === digit);
    let index = unique_diseases.indexOf(digitObject);
    let place = index + 1
    let final = place % 15
    if(final === 0) final = 15

    if(final === 1) return {background: img1, size: '100%', imageid: 'img1'}
    else if(final === 2) return {background: img2, size: '100%', imageid: 'img2'}
    else if(final === 3) return {background: img3, size: '100%', imageid: 'img3'}
    else if(final === 4) return {background: img4, size: '70%', imageid: 'img4'}
    else if(final === 5) return {background: img5, size: '35%', imageid: 'img5'}
    else if(final === 6) return {background: img6, size: '35%', imageid: 'img6'}
    else if(final === 7) return {background: img7, size: '100%', imageid: 'img7'}
    else if(final === 8) return {background: img8, size: '50%', imageid: 'img8'}
    else if(final === 9) return {background: img9, size: '55%', imageid: 'img9'}
    else if(final === 10) return {background: img10, size: '20%', imageid: 'img10'}
    else if(final === 11) return {background: img11, size: '60%', imageid: 'img11'}
    else if(final === 12) return {background: img12, size: '25%', imageid: 'img12'}
    else if(final === 13) return {background: img13, size: '35%', imageid: 'img13'}
    else if(final === 14) return {background: img14, size: '90%', imageid: 'img14'}
    else if(final === 15) return {background: img15, size: '80%', transform: 'rotate(90deg)', imageid: 'img15'}

    return {background: img1, size: '100%'}

  }

  getColor(digit, unique_diseases, colorIndex) {
    let colorId = null;
    colorId = colorIndex % 200; // 200 different colors

    let firstTenDiseases = unique_diseases.slice(0, 10);
    let digitOnFirstTen = firstTenDiseases.find(disease => disease.disease_id === digit);

    if(digitOnFirstTen){
      let index = firstTenDiseases.indexOf(digitOnFirstTen);
      switch(index){
        case 0:
          return '#0066cc';
        case 1:
          return '#cc0000';
        case 2:
          return '#009933';
        case 3:
          return '#ffcc00';
        case 4:
          return '#990099';
        case 5:
          return '#ff6600';
        case 6:
          return '#33ccff';
        case 7:
          return '#ff6699';
        case 8:
          return '#00ff66';
        case 9:
          return '#cc99ff';
      }
    }
    else{
      let color = colors_255.find(item => item.colorId === colorId)
      // color id for White or color undefined
      if(typeof(color) === 'undefined') {
        return '#9370DB';
      }
      return color.hexString;
    }
  }

  loadDiseases() {
    const unique_disease_count = this.unique_diseases.length;
    if (unique_disease_count === 0) {
      this.container_element.innerHTML = "No diseases to display";
    } else {

      if (unique_disease_count > 5) {
        this.redrawLegend();
      }

      for(let i=0; i<this.unique_diseases.length; i++) {
        // get the current disease
        const disease = this.unique_diseases[i];

        // create row container
        const row = document.createElement('div');
        row.setAttribute('class', 'legend-dom-row');

        row.appendChild(this.renderEyeColumn(disease));
        row.appendChild(this.renderNameColumn(disease));

        this.container_element.appendChild(row);
      }

    }
  }

  renderEyeColumn(disease) {
    // create column element for eye Image
    const disease_eye_column = document.createElement('div');
    disease_eye_column.setAttribute('class', 'legend-dom-column-one');

    // create the eye image element
    const eye_image = this.renderEyeImg(disease);

    // add eye image to column and the column to the row
    disease_eye_column.appendChild(eye_image);

    return disease_eye_column;
  }

  renderEyeImg(disease) {
    const eye_image = document.createElement('img');
    eye_image.addEventListener('mouseenter', () => {
      document.body.style.cursor = "pointer";
    });

    eye_image.addEventListener('mouseleave', () => {
      document.body.style.cursor = "move";
    });

    let hidden_disease_colors = this.options.hiddenDiseaseColors;
    hidden_disease_colors = hidden_disease_colors.filter(d => {
      if( (d.disease_id && d.disease_id === disease.disease_id) ||
          (d.umls_id && d.umls_id === disease.disease_id)) {

        return d;
      }
    });

    const toggleDisease = this.options.toggleDisease
    eye_image.addEventListener('click', (event) => {
      if(hidden_disease_colors.length > 0){
        event.target.src = EYE_IMAGE_SLASHED;
        toggleDisease(disease.disease_id, false);
      }
      else{
        event.target.src = EYE_IMAGE;
        toggleDisease(disease.disease_id, true);
      }
    });

    if(hidden_disease_colors.length > 0){
      eye_image.src = EYE_IMAGE_SLASHED;
    }
    else{
      eye_image.src = EYE_IMAGE;
    }

    return eye_image;
  }

  renderNameColumn(disease) {
    const disease_column = document.createElement('div');
    disease_column.setAttribute('class', 'legend-dom-column-two');

    const inner_row = document.createElement('div');
    inner_row.setAttribute('class', 'legend-dom-inner-row');

    const inner_column_one = document.createElement('div');
    inner_column_one.setAttribute('class', 'legend-dom-inner-column-one');

    // create and add disease color and name column to the row
    let disease_color = document.createElement('div');
    disease_color.setAttribute('class', 'legend-dom-color-square');

    let displayBlackAndWhite = Cookie.get('famgenix_pedigree_black_and_white');
    const displayBlackAndWhiteBool = displayBlackAndWhite === 'true';

    if(displayBlackAndWhiteBool) {
      disease_color.style.backgroundImage = disease.color.background;
      disease_color.style.backgroundSize = disease.color.size
      disease_color.setAttribute('data-imageid', disease.color.imageid);
      if(disease.color.transform){
        disease_color.style.transform = disease.color.transform
      }
      disease_color.style.border = 'none'
    }
    else{
      disease_color.style.background = disease.color;
      disease_color.style.borderColor = disease.color;
    }

    inner_column_one.appendChild(disease_color);

    const inner_column_two = document.createElement('div');
    inner_column_two.setAttribute('class', 'legend-dom-inner-column-two');

    // create and add disease color and name column to the row
    const disease_name = document.createElement('div');
    let name = disease.disease_name;
    disease_name.innerHTML = name;
    inner_column_two.appendChild(disease_name);

    inner_row.appendChild(inner_column_one);
    inner_row.appendChild(inner_column_two);
    disease_column.appendChild(inner_row);

    return disease_column;
  }

  loadNotes(){
    //create notes div within container
    const disease_column = document.createElement('div');
    disease_column.setAttribute('id', constants.PEDIGREE_NOTES_CONTAINER_ELEMENT);
    disease_column.setAttribute('class', 'legend-dom-row-notes');
    disease_column.innerHTML = 'Pedigree Notes'

    if(this.options.showDiseases) disease_column.style.paddingTop = '20px'
    const textField = this.createNotes();
    disease_column.appendChild(textField)

    this.container_element.appendChild(disease_column)
  }

  createNotes(event){
    let savePedigreeNotes = this.options.savePedigreeNotes
    let pedigreeNotes = this.options.pedigreeNotes

    const setNotesFocused = this.setNotesFocused;

    //create text area field and allow a click event that will focus on the element
    const textField = document.createElement('textarea')
    textField.setAttribute('id', constants.PEDIGREE_NOTES_ELEMENT)
    textField.addEventListener('click', (event) => {
      textField.focus();
      setNotesFocused(true);
    })

    textField.addEventListener('blur', (event) => {
      setNotesFocused(false);
      let notes = document.getElementById('legend-notes');
      savePedigreeNotes(notes.value);
    });

    if(this.options.pedigreeNotes && this.options.pedigreeNotes.length > 0){
      var wom = this.options.pedigreeNotes.match(/\S+/g);
      let wordCount = wom ? wom.length : 0
      textField.value = this.options.pedigreeNotes
      let rows = (wordCount/ 6) + 2
      textField.setAttribute('rows', rows)
    }
    this.redrawLegend()


    return textField
  }

  redrawLegend() {
    this.container_element.style.height = `fit-content`;
  }

  onCloseClicked(event) {
    this.options.parentNode.removeChild(this.container_element);
    document.body.style.cursor = "default";

    if ('onClose' in this.options) this.options.onClose();
  }

}

export default LegendDOM;
